'use client'

import { useEffect, useRef } from 'react'

import { isNullOrUndefined } from 'shared/utils/ramda'

import { syneriseEventCartStatus } from '../analytics'
import { useCart } from '../store/cartStore'

const SyneriseCartUpdate = () => {
  const lastValueRef = useRef<number | null>(null)
  const cart = useCart()

  useEffect(() => {
    if (!window?.SR?.event?.trackCustomEvent || !cart) return

    if (isNullOrUndefined(cart.totalValueGross?.value)) return

    if (lastValueRef.current === cart.totalValueGross.value) return

    lastValueRef.current = cart.totalValueGross.value
    void syneriseEventCartStatus(cart)
  }, [cart?.totalValueGross?.value])

  return null
}

export default SyneriseCartUpdate
